// console-spa root component。
// Hash router 决定渲染哪一页；未登录时强制重定向 #/login。

import { useEffect } from 'react';
import { useHashRoute, navigate, type RouteName } from './lib/route';
import { clearSession, readSession } from './lib/storage';
import { Login } from './pages/Login';
import { Sites } from './pages/Sites';
import { Dashboard } from './pages/Dashboard';
import { Logs } from './pages/Logs';

export function App(): JSX.Element {
  const route = useHashRoute();
  const sess = readSession();

  // 未登录 → 强制 #/login
  useEffect(() => {
    if (sess === null && route !== 'login') navigate('login');
  }, [sess, route]);

  if (sess === null || route === 'login') return <Login />;

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <TopBar email={sess.email} active={route} onLogout={() => { clearSession(); navigate('login'); }} />
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: 24 }}>
        {route === 'sites' && <Sites />}
        {route === 'dashboard' && <Dashboard />}
        {route === 'logs' && <Logs />}
      </main>
    </div>
  );
}

function TopBar(props: { email: string; active: RouteName; onLogout: () => void }): JSX.Element {
  return (
    <header style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '12px 24px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 24 }}>
        <strong>Captcha SaaS</strong>
        <nav style={{ display: 'flex', gap: 16 }}>
          <NavLink to="sites" active={props.active === 'sites'}>Sites</NavLink>
          <NavLink to="dashboard" active={props.active === 'dashboard'}>仪表盘</NavLink>
          <NavLink to="logs" active={props.active === 'logs'}>调用日志</NavLink>
        </nav>
        <span style={{ marginLeft: 'auto', fontSize: 13, color: '#64748b' }}>{props.email}</span>
        <button onClick={props.onLogout} style={ghostBtn}>登出</button>
      </div>
    </header>
  );
}

function NavLink(props: { to: RouteName; active: boolean; children: React.ReactNode }): JSX.Element {
  return (
    <a
      href={`#/${props.to}`}
      style={{
        textDecoration: 'none',
        color: props.active ? '#2563eb' : '#475569',
        fontWeight: props.active ? 600 : 400,
        fontSize: 14,
      }}
    >
      {props.children}
    </a>
  );
}

const ghostBtn: React.CSSProperties = {
  background: 'transparent',
  border: '1px solid #cbd5e1',
  borderRadius: 6,
  padding: '4px 10px',
  fontSize: 12,
  cursor: 'pointer',
};
